import { render, staticRenderFns } from "./SysParamsList.vue?vue&type=template&id=6fd2500a&scoped=true&"
import script from "./SysParamsList.vue?vue&type=script&lang=js&"
export * from "./SysParamsList.vue?vue&type=script&lang=js&"
import style0 from "./SysParamsList.vue?vue&type=style&index=0&id=6fd2500a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2500a",
  null
  
)

export default component.exports